import React from "react";
import "../../assets/css/como-participar.css";
import { getSrcSet, getSizes, getResponsiveImage, buildCmsUrl } from "../../utils/imageHelper";



interface ComoParticiparComponentProps {
  worldCupData?: any;
}

const ComoParticiparComponent: React.FC<ComoParticiparComponentProps> = ({ worldCupData }) => {



  const participeCards = worldCupData?.participe_cards || [];

  if (!worldCupData) {
    return null;
  }

  return (
    <section className="como-participar-section" id="como-participar">
      <div className="como-participar-bg">
        <div className="como-participar-bg-right"></div>
      </div>
      
      <div className="como-participar-container">
        
        <h2 className="como-participar-title">{worldCupData.participate_title}</h2>
        <p className="como-participar-subtitle">
          {worldCupData.participe_description}
        </p>
        
        <div className="como-participar-cards">
          {participeCards.map((card: any) => (
            <div key={card.id} className="como-participar-card">
              <div className="como-participar-icon">
                <img 
                  src={buildCmsUrl(card.img.url)} 
                  srcSet={getSrcSet(card.img?.url || '')}
                  sizes={getSizes('100px')}
                  alt={card.text} 
                />

              </div>
              <p className="como-participar-card-text">
                {card.text}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ComoParticiparComponent;